module.exports = __webpack_public_path__ + "static/media/falcongreen.46f0df36.png";